import React from "react";
import { useNavigate } from "react-router-dom";
import Button from '../components/Button';

export default function Recetas() {
  const navigate = useNavigate();

  return (
    <div className="p-4 max-w-xl mx-auto flex flex-col gap-4">

      {/* Encabezado */}
      <div className="flex items-center justify-center">
        <h3 className="font-bold text-center">RECETAS</h3>
      </div>

      {/* Recetas */}

      <div className="flex flex-col gap-4 mt-2 font-semibold text-white">
        <Button onClick={() => navigate("/receta/recetas-disfagia")}>
          Recetas de disfagia
        </Button>

        <Button onClick={() => navigate("/receta/menu-disfagia")}>
          Menús adaptados para disfagia
        </Button>
      </div>
    </div>
  );
}